module.exports = __webpack_public_path__ + "img/img-afdea1b9.4b08efa0.png";